exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-7a5c4130] {\n  padding: 6px 20px;\n}\n.no-img[data-v-7a5c4130] {\n  background: #eaeef4;\n}\n.wechat1[data-v-7a5c4130] {\n  height: 40px;\n  position: relative;\n}\n.wechat1 .wechat-view[data-v-7a5c4130] {\n  height: 40px;\n  position: absolute;\n  z-index: 10;\n  padding: 0 10px;\n}\n.wechat1 .wechat-view.is-left[data-v-7a5c4130] {\n  left: 0;\n  border-top-left-radius: 0!important;\n  border-bottom-left-radius: 0!important;\n}\n.wechat1 .wechat-view.is-right[data-v-7a5c4130] {\n  right: 0;\n  border-top-right-radius: 0!important;\n  border-bottom-right-radius: 0!important;\n}\n", ""]);

// exports
